import { useTranslation } from 'react-i18next'
import { setSecureItem } from '@/shared/lib/storage'
import { LANGUAGE_STORAGE_KEY, LANGUAGE } from '@/shared/constants/language'
import { useUpdateUserPreferences } from '@/shared/hooks/use-update-user-preferences'

export type Language = (typeof LANGUAGE)[keyof typeof LANGUAGE]

export function useLanguage() {
  const { i18n, t } = useTranslation()
  const currentLanguage = i18n.language as Language
  const { mutate: updatePreferences } = useUpdateUserPreferences()

  async function setLanguage(lang: Language) {
    await i18n.changeLanguage(lang)
    await setSecureItem(LANGUAGE_STORAGE_KEY, lang)
  }

  async function updateLanguage(lang: Language) {
    if (lang === currentLanguage) return
    await setLanguage(lang)
    const newLanguage = lang === LANGUAGE.EN ? 'English' : 'Spanish'
    updatePreferences({ language: newLanguage })
  }

  async function toggleLanguage() {
    const next = currentLanguage === LANGUAGE.EN ? LANGUAGE.ES : LANGUAGE.EN
    await updateLanguage(next)
  }

  return {
    currentLanguage,
    toggleLanguage,
    setLanguage,
    updateLanguage,
    switchLabel: t('login.switchLanguage'),
  }
}
